import { init } from './helpers'

init(window)
